/**
 * Розбиває текст заголовка на слова, кожне — в свій <span class="w"><i>...</i></span>,
 * щоб CSS (.anim-words) міг анімувати їх послідовно (transition-delay через --d).
 */
function animateWords(el) {
	if (el.dataset.split) return;
	el.dataset.split = '1';

	const nodes = Array.from(el.childNodes);
	el.textContent = '';
	let i = 0;

	const put = (inner) => {
		const w = document.createElement('span');
		w.className = 'w';
		inner.style.setProperty('--d', (i * 0.045).toFixed(3) + 's');
		w.appendChild(inner);
		el.appendChild(w);
		el.appendChild(document.createTextNode(' '));
		i++;
	};

	nodes.forEach((node) => {
		if (node.nodeType === Node.TEXT_NODE) {
			node.textContent
				.split(/\s+/)
				.filter(Boolean)
				.forEach((word) => {
					const inner = document.createElement('i');
					inner.style.fontStyle = 'normal';
					inner.textContent = word;
					put(inner);
				});
		} else if (node.nodeType === Node.ELEMENT_NODE) {
			put(node);
		}
	});
}

/**
 * Авто-розмітка reveal-класів для блоків, зібраних із core-блоків (Type C).
 *
 * Проблема: у Type C ми не пишемо власну розмітку (вміст — core/heading,
 * core/paragraph, core/image), тому й не можемо "вручну" повісити класи
 * .reveal/.anim-words у render/save, як робимо в Type A/B. Рішення: вішаємо
 * їх тут, на фронтенді, за структурою блока.
 *
 * ⚠️ ТІЛЬКИ текст — зображення (core/image) НЕ анімуємо (свідомо: іконки й
 * банер мають зʼявлятись одразу, це вимога дизайну).
 */
const AUTO_REVEAL = [
	{
		block: '.wp-block-hotel-details',
		words: 'h2',              // заголовок секції — по словах
		fade: 'p, h3',            // eyebrow, назви й описи карток — фейд
	},
];

function autoDecorate() {
	AUTO_REVEAL.forEach(({ block, words, fade }) => {
		document.querySelectorAll(block).forEach((root) => {
			root.querySelectorAll(words).forEach((el) => el.classList.add('anim-words'));

			root.querySelectorAll(fade).forEach((el, i) => {
				el.classList.add('reveal');
				// Легкий каскад — елементи зʼявляються один за одним.
				el.style.setProperty('--delay', (i * 0.05).toFixed(2) + 's');
			});
		});
	});
}

/**
 * Анімація появи при скролі: .reveal / .anim-words / .reveal-img отримують
 * .is-in, коли потрапляють у viewport (IntersectionObserver). Контент над
 * "фолдом" (напр. Hero) анімується одразу при завантаженні — він вже видимий.
 */
export default function scrollReveal() {
	autoDecorate();

	document.querySelectorAll('.anim-words').forEach(animateWords);

	const els = document.querySelectorAll('.reveal, .anim-words, .reveal-img');
	if (!els.length) return;

	if (!('IntersectionObserver' in window)) {
		els.forEach((el) => el.classList.add('is-in'));
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-in');
					observer.unobserve(entry.target);
				}
			});
		},
		{ threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
	);

	els.forEach((el) => observer.observe(el));
}
